import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'rsuite';

import './nextcloudButton.css';

interface Props {
  onClick: () => void;
  signUp?: boolean;
}

export const NextcloudSignInButton: React.FC<Props> = ({ onClick, signUp }) => {
  const { t } = useTranslation();
  return (
    <Button block className="login-with-nextcloud-btn flex items-center justify-center" onClick={onClick}>
      <img src="https://najmuje.eu/apps/theming/image/logo?v=15" className="w-8 h-8 mr-2" />
      {signUp ? t('AUTH.SIGN_IN.SIGN_UP_WITH_NEXTCLOUD') : t('AUTH.SIGN_IN.SIGN_IN_WITH_NEXTCLOUD')}
    </Button>
  );
};
